import { Controller } from "@hotwired/stimulus";

const MOON = '<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79Z"></path>';
const SUN =
  '<circle cx="12" cy="12" r="4"></circle>' +
  '<path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"></path>';

export default class extends Controller {
  static targets = ["button", "icon", "label"];
  static values = { lightLabel: String, darkLabel: String };

  connect() {
    this.sync(document.documentElement.getAttribute("data-theme") === "dark");
  }

  toggle() {
    const isDark = document.documentElement.getAttribute("data-theme") === "dark";
    const nextDark = !isDark;
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const applyTheme = () => {
      if (nextDark) {
        document.documentElement.setAttribute("data-theme", "dark");
        localStorage.setItem("theme", "dark");
      } else {
        document.documentElement.removeAttribute("data-theme");
        localStorage.setItem("theme", "light");
      }
      this.sync(nextDark);
    };

    if (reduceMotion) {
      applyTheme();
      return;
    }

    // brief window where every color/border/shadow cross-fades instead of snapping
    document.documentElement.classList.add("theme-transitioning");
    window.setTimeout(() => document.documentElement.classList.remove("theme-transitioning"), 260);

    // icon exits (accelerate) before the swap, then settles in (decelerate)
    this.iconTargets.forEach((el) => el.classList.add("icon-swap-out"));
    window.setTimeout(() => {
      applyTheme();
      this.iconTargets.forEach((el) => el.classList.remove("icon-swap-out"));
    }, 100);
  }

  sync(isDark) {
    this.iconTargets.forEach((el) => { el.innerHTML = isDark ? MOON : SUN; });
    this.labelTargets.forEach((el) => {
      el.textContent = isDark ? this.darkLabelValue : this.lightLabelValue;
    });
    this.buttonTargets.forEach((el) => {
      el.setAttribute("aria-pressed", String(isDark));
    });
  }
}
